<template lang="html">
	<div class="form">

		<div class="field">
			<label>
				<input type="text"
						:placeholder='field1.placeholder'
						v-model='client_name'>

				<span class="validation-error" :error='showRequiredName'>
					<span class="required">{{field1.validator}}</span>
				</span>
			</label>
		</div>

		<div class="field">
			<label class='phone'>
				<input type="tel"
					:placeholder='field2.placeholder'
					v-model='client_phone'
				>
				<span class="validation-error" :error='showRequiredPhone'>
					<span class="required">{{field2.validator}}</span>
				</span>
			</label>
		</div>

		<div class="field">
			<label class='email'>
				<input type="text"
						:placeholder='field3.placeholder'
						v-model='client_email'
						>
				<span class="validation-error" :error='showRequiredEmail'>
					<span class="required">{{field3.validator}}</span>
				</span>
			</label>
		</div>

		<div class="field bl">
			<label>
				<textarea :placeholder='field4.placeholder' @input='textInput($event)'></textarea>
			</label>
		</div>

		<div class="row">
			<div class="cols s_24 m_12 s_order-2 m_order-1">
				<div class="submit">
					<button @click='click'>{{data.button}}</button>
				</div>
			</div>

			<div class="cols s_24 m_12 s_order-1 m_order-2">
				<div class="upload">
					<file-upload
						v-if="field5.type"
						v-model="files"
						@input='input'
						@input-file='inputFile'
						>

						<img :src='window.YAMASTERS_FRONTEND.templatePath + "img/paperclip.png"' alt="" />
						<div class="txt">{{field5.placeholder}}</div>
					</file-upload>
				</div>
			</div>
		</div>

		<grecaptcha
			:request='request'
			:payload='payload'
			@SENDFORM='onRecaptchaSubmit'
		/>
	</div>
</template>

<script>
const Inputmask = require('inputmask');
const FileUpload = require('vue-upload-component');

module.exports = {


	components: {
		grecaptcha: require('./elements/grecaptcha.vue'),
		FileUpload
	},

	props: {
		data: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			client_name: '',
			client_email: '',
 			client_phone: '',
			client_name: '',
			client_req: '',
			files: [],
			test: '',

			completeName: false,
			completePhone: false,
			completeEmail: false,

			showRequiredName: false,
			showRequiredPhone: false,
			showRequiredEmail: false,

			grcID: null,
			window: window,

			payload: {}
		}
	},

	computed: {
		field1() {
			return this.data.fields ? this.data.fields[0] : {};
		},
		field2() {
			return this.data.fields ? this.data.fields[1] : {};
		},
		field3() {
			return this.data.fields ? this.data.fields[2] : {};
		},
		field4() {
			return this.data.fields ? this.data.fields[3] : {};
		},
		field5() {
			return this.data.fields ? this.data.fields[4] : {};
		},

		request() {
			return this.data ? this.data.request : {};
		}
	},

	methods: {
		setFieldValidation(payload) {
			this.fieldsAfterValidation = objectMerge(this.fieldsAfterValidation, payload);
		},
		validateFields() {
			this.formIsValid = true;

			for (var ref in this.$refs) {
				if (this.$refs.hasOwnProperty(ref)) {

					let el;

					if(this.$refs[ref][0]) {
						el = this.$refs[ref][0];
					}
					else {
						el = this.$refs[ref]
					}

					el.validate(ref);
				}
			}

			// console.log(this.fieldsAfterValidation);
			for (var ref in this.fieldsAfterValidation) {
				if (this.fieldsAfterValidation.hasOwnProperty(ref)) {
					if(!this.fieldsAfterValidation[ref]) {
						this.formIsValid = false;

						if(this.$refs[ref][0]) {
							this.onIncomplete(this.$refs[ref][0].$el)
						}
						else {
							this.onIncomplete(this.$refs[ref].$el)
						}
						break;
					}
				}
			}

			// console.log(this.formIsValid);

			if(this.formIsValid) {
				this.$emit('SUBMIT', this.payload)
			}
			else {
				// console.warn('Form is not valid!');
				return false;
			}
		},
		onRecaptchaSubmit(payload) {
			this.$emit('SENDFORM', payload);
		},
		input(files) {
			console.log(files);
		},
		inputFile(newFile, oldFile) {
			console.log(`newFile: ${newFile}`);
			console.log(`oldFile: ${oldFile}`);
		},

		textInput(e) {
			this.client_req = e.target.value;
		},

		click() {

			if(this.completeName && this.completePhone && this.completeEmail) {
				// console.log(this.data);
				this.payload = {
					[this.field1.name]: this.client_name,
					[this.field2.name]: this.client_phone,
					[this.field3.name]: this.client_email,
					[this.field4.name]: this.client_req,
					[this.field5.name]: this.files
				}
			}
			else {

				if(!this.completeName) {
					this.showRequiredName = true;
				}
				if(!this.completePhone) {
					this.showRequiredPhone = true;
				}
				if(!this.completeEmail) {
					this.showRequiredEmail = true;
				}

			}
		}
	},

	watch: {
		client_name() {
			if(this.client_name.length >= 2) {
				this.completeName = true;
				this.showRequiredName = false;
			}
			else {
				this.completeName = false;
			}
		}
	},

	mounted() {

		this.$parent.$on('clear', () => {
			this.client_name = ''
			this.client_phone = this.field2.value;
			this.client_email = ''
			this.$el.querySelector('textarea').value = '';
			this.client_req = ''
			this.files = []

			this.completeName = false
			this.completePhone = false
			this.completeEmail = false

			this.showRequiredName = false
			this.showRequiredPhone = false
			this.showRequiredEmail = false

		})

		let phone = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.tel.default,
			definitions: {
				'9': '',
				'x': {
					validator: "[0-9\\s]",
					cardinality: 1,
					casing: "lower"
				}
			},
			oncomplete: () => {
				console.log('tel oncomplete');
				this.completePhone = true;
				this.showRequiredPhone = false;
			},
			onincomplete: () => {
				console.log('tel oncomplete');
				this.completePhone = false;
			},
			oncleared: () => {
				console.log('tel oncleared');
				this.completePhone = false;
			}
		});

		phone.mask(this.$el.querySelector('.phone input'));


		let email = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.email,
			greedy: false,
			definitions: {
				'*': {
					validator: "[0-9A-Za-z_-]",
					cardinality: 1,
					casing: "lower"
				},
				'@': {
					validator: '@',
					cardinality: 1,
					casing: 'lower'
				},
				'd': {
					validator: '.',
					cardinality: 1,
					casing: 'lower'
				}
			},
			oncomplete: () => {
				// console.log('oncomplete');
				this.completeEmail = true;
				this.showRequiredEmail = false;
			},
			onincomplete: () => {
				this.completeEmail = false;
			},
			oncleared: () => {
				this.completeEmail = false;
			}
		});

		email.mask(this.$el.querySelector('.email input'));

		this.$on('clear', () => {
			this.client_phone = this.field2.value;
		})

		let timerid = setTimeout(() => {
		  this.$emit('clear');
	  }, 1000);
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";

	.VForm.contacts {
		margin: 0 0 73px;

		.form {
			max-width: rem(495);
			margin: 0 auto;
			box-shadow: 0px 0px 30px 0px rgba(#000, 0.1);
			border-radius: 16px;
			@include single-transition;
			padding: 20px;
			@include m__up {
				padding: 60px;
			};

			&:hover {
				box-shadow: 0px 0px 30px 0px rgba(#000, 0.2);
			}

			[grecaptcha] {
				display: none;
			}

			.upload {
				margin: 0 0 29px;

				.file-uploads {
					height: 61px;
					display: flex;
					align-items: center;
					cursor: pointer;
					justify-content: center;
					@include m_up {
						justify-content: flex-end;
					};

					.txt {
						font-family: $Circe_bold;
						font-size: 15px;
						color: #303339;
						padding: 0 0 0 10px;
					}
				}
			}
			.field {
				margin: 0 0 20px;

				&.bl {
					margin: 0 0 30px;
				}

				label {
					display: block;
					position: relative;


					input {

						&[type='text'], &[type='tel'], &[type='mail'] {
							height: rem(61);
							border-radius: rem(30);
							border: 1px solid #2B3036;
							text-align: center;
							color: #303339;
							padding: 0 rem(25);
							@include single-transition;
							@include placeholder {
								color: #97999c;
								opacity: 1;
							};
							@include m___up {
								text-align: left;
							};

							&:focus {
								border-color: #141619;
							}
						}
					}

					textarea {
						height: rem(121);
						border-radius: rem(30);
						border: 1px solid #2B3036;
						text-align: center;
						color: #303339;
						padding: 18px rem(25) 5px;
						resize: none;
						@include single-transition;
						@include placeholder {
							color: #97999c;
							opacity: 1;
						};
						@include m___up {
							text-align: left;
						};

						&:focus {
							border-color: #141619;
						}
					}

					.validation-error {
						position: absolute;
						left: rem(25);
						right: rem(25);
						font-size: rem(12);
						color: #00B3E9;
						display: block;
						z-index: 1;
						@include s_up {
							top: rem(43);
							text-align: center;
						};
						@include m___up {
							top: calc(100% - 20px);
							text-align: left;
						};

						&[error] .required {
							opacity: 1;
							transform: translateY(0px);
						}

						.required {
							display: block;
							transform: translateY(5px);
							opacity: 0;
							@include single-transition;
						}
					}
				}
			}

			.submit {

				button {
					height: rem(61);
					border-radius: rem(30);
					background-color: #E6DF39;
					border: none;
					color: #303339;
					@include single-transition;

					&:hover {
						background-color: #dcd829;
					}

					&:active {
						background-color: #CFCA34;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// contacts.vue?1c83d199